import "../../../styles/login.css";
import { uiState } from "../../state/uiState.js";
import logo from "../../../images/logo-koyu.svg";

function ensureSifreSifirlamaDialog() {
    if (document.getElementById("sifreSifirlamaDialog")) return;
    document.body.insertAdjacentHTML(
        "beforeend",
        `
<dialog id="sifreSifirlamaDialog">
    <div class="delete-dialog-container">
        <div class="delete-dialog-header">
            <div class="delete-header-icon" style="background:#eff6ff;">
                <span class="material-icons" style="color:#3b82f6;">lock_reset</span>
            </div>
            <h2>Şifre Sıfırlama</h2>
            <button type="button" class="delete-dialog-close" aria-label="Kapat">
                <span class="material-icons">close</span>
            </button>
        </div>
        <hr class="delete-divider" />
        <div class="delete-dialog-body">
            <p>Sistem şifrenizi yalnızca yetkili IT personeli sıfırlayabilir. Şifre sıfırlama talebinizi aşağıdaki adrese e-posta ile iletiniz.</p>
            <div class="delete-dialog-card">
                <div class="delete-card-icon">
                    <span class="material-icons">mail</span>
                </div>
                <div class="delete-card-info">
                    <div class="delete-dialog-id">IT DESTEK</div>
                    <div class="delete-dialog-name">it@ornek-sirket.com</div>
                </div>
            </div>
            <div class="delete-dialog-warning sifre-sifirlama-not">
                <span class="material-icons">info</span>
                <span>Lütfen talebinizde adınızı, soyadınızı ve sisteme kayıtlı e-posta adresinizi belirtiniz. Talepler mesai saatleri içinde işleme alınacaktır.</span>
            </div>
        </div>
        <div class="delete-dialog-footer">
            <button type="button" class="delete-cancel sifre-sifirlama-tamam">Tamam</button>
        </div>
    </div>
</dialog>`,
    );

    const dialog = document.getElementById("sifreSifirlamaDialog");
    dialog.querySelector(".delete-dialog-close").addEventListener("click", () => dialog.close());
    dialog.querySelector(".sifre-sifirlama-tamam").addEventListener("click", () => dialog.close());
}

export function renderLoginPage({ onSuccess } = {}) {
    if (document.getElementById("login-screen")) return;

    ensureSifreSifirlamaDialog();

    const div = document.createElement("div");
    div.id = "login-screen";
    div.innerHTML = `
        <div class="login-karti">
            <div class="login-baslik">
                <img class="login-logo-img" src="${logo}" alt="Envanter" />
                <div class="login-ayrac"></div>
                <div class="login-baslik-yazi">Sisteme Giriş</div>
            </div>

            <div class="login-hata" id="loginMesaj" hidden></div>

            <form id="loginForm" novalidate>
                <div class="login-alan">
                    <label class="login-alan-etiket" for="login-email">Email</label>
                    <input id="login-email" class="login-alan-input" type="email" name="email"
                        placeholder="ornek@ornek-sirket.com" required autocomplete="username" />
                </div>
                <div class="login-alan">
                    <label class="login-alan-etiket" for="login-sifre">Şifre</label>
                    <input id="login-sifre" class="login-alan-input" type="password" name="sifre"
                        required autocomplete="current-password" />
                </div>

                <div class="login-alt-satir">
                    <label class="login-hatirla">
                        <span class="login-hatirla-kutu" id="hatirlaKutu"></span>
                        <input type="checkbox" name="beniHatirla" id="beniHatirla" style="display:none" />
                        <span class="login-hatirla-yazi">Beni hatırla</span>
                    </label>
                    <button type="button" class="login-sifre-unuttum">Şifremi unuttum</button>
                </div>

                <button type="submit" class="login-buton" id="loginBtn">Giriş Yap</button>
            </form>

            <div class="login-alt-bilgi">
                Hesabınız yoksa sistem yöneticinize başvurun.
            </div>
        </div>
    `;
    document.body.appendChild(div);

    const form     = div.querySelector("#loginForm");
    const mesajEl  = div.querySelector("#loginMesaj");
    const btn      = div.querySelector("#loginBtn");
    const emailEl  = div.querySelector("[name=email]");
    const sifreEl  = div.querySelector("[name=sifre]");
    const kutu     = div.querySelector("#hatirlaKutu");
    const checkbox = div.querySelector("#beniHatirla");

    // Demo modunda giriş bilgileri hazır gelir
    fetch("/api/demo-bilgi")
        .then((r) => r.json())
        .then((d) => {
            if (!d?.demo) return;
            emailEl.value = d.email;
            sifreEl.value = d.sifre;
            const not = document.createElement("div");
            not.className = "login-demo-not";
            not.innerHTML = "<strong>Demo</strong> — bilgiler hazır, <strong>Giriş Yap</strong>'a basmanız yeterli. Kayıtların tamamı kurgusaldır ve her gece sıfırlanır.";
            form.before(not);
        })
        .catch(() => {});

    div.querySelector(".login-sifre-unuttum").addEventListener("click", () => {
        document.getElementById("sifreSifirlamaDialog").showModal();
    });

    // Custom checkbox toggle
    checkbox.addEventListener("change", () => {
        kutu.classList.toggle("login-hatirla-kutu--secili", checkbox.checked);
    });

    function showHata(mesaj) {
        mesajEl.textContent = mesaj;
        mesajEl.className = "login-hata login-hata--hata";
        mesajEl.hidden = false;
    }

    function showBasari(mesaj) {
        mesajEl.textContent = mesaj;
        mesajEl.className = "login-hata login-hata--basari";
        mesajEl.hidden = false;
    }

    function clearHata() {
        mesajEl.hidden = true;
        emailEl.classList.remove("login-alan-input--hata");
        sifreEl.classList.remove("login-alan-input--hata");
    }

    form.addEventListener("submit", async (e) => {
        e.preventDefault();
        clearHata();

        const email       = emailEl.value.trim();
        const sifre       = sifreEl.value;
        const beniHatirla = checkbox.checked;

        // Client-side empty validation
        if (!email || !sifre) {
            if (!email) emailEl.classList.add("login-alan-input--hata");
            if (!sifre) sifreEl.classList.add("login-alan-input--hata");
            showHata("Lütfen tüm alanları doldurun.");
            return;
        }

        btn.disabled = true;
        btn.textContent = "Kontrol ediliyor...";

        try {
            const res  = await fetch("/api/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, sifre, beniHatirla }),
            });
            const data = await res.json();

            if (!data.ok) {
                emailEl.classList.add("login-alan-input--hata");
                sifreEl.classList.add("login-alan-input--hata");
                showHata(data.error || "Giriş başarısız.");
                btn.disabled = false;
                btn.textContent = "Giriş Yap";
                return;
            }

            showBasari("Giriş başarılı. Yönlendiriliyor...");
            btn.textContent = "Yönlendiriliyor...";
            uiState.currentUser = data.user;

            setTimeout(() => {
                div.remove();
                if (onSuccess) onSuccess(data.user);
            }, 600);

        } catch {
            showHata("Sunucuya bağlanılamadı.");
            btn.disabled = false;
            btn.textContent = "Giriş Yap";
        }
    });
}
